<template>
	<div style='max-width:100%;width:100%;'>	
		<router-view></router-view>
		<DialogModal></DialogModal>
		
	</div>
</template>
	
<script>
import DialogModal from '@/common/DialogModal'
export default {
	name: 'app',
	components: {
		'DialogModal':DialogModal
	},
	watch: {
		'$route' (to, from) {
			
		}
	},
	created() {
	},
	methods: {
		
		
	},
	mounted() {
		
		
	}

}
</script>
<style lang="scss">
body {-ms-user-select: none; -moz-user-select: -moz-none; -webkit-user-select: none; -khtml-user-select: none; user-select:none;}

*    {
     margin:0;
	 padding:0;
}
a    {
     text-decoration:none;
}
li    {
      list-style:none;
}
.form-group .md-error-box {display:none;margin-top:-10px;font-size:11px;color:#ff3300;}
.form-group.md-invalid .md-error-box {display:block;}
.form-group .md-warning-box {margin-top:-10px;font-size:11px;display:block;}

.form-group.md-warning-invalid .md-warning-box {color:#cc0000;}
.form-group.md-warning-invalid .fail-warning-hide {display:block;}

.form-group.md-invalid .md-warning-box {display:none;}
.form-group.md-invalid .fail-warning-hide {display:none;}

.form-group .succ-warning {color:#009900;}
.form-group .fail-warning {color:#cc0000;}
.form-group .fail-warning-hide {color:#cc0000;display:none;}

ul {list-style:none;padding:0;margin:0;}
h3 {
	font-size:15pt;
}

.md-icon-button {
	i {
		color:#515F83;
		font-size:14pt;
		font-weight:bold;
		position:relative;
		bottom:-2px;
	}
}
.md-toolbar {
	.title {
		font-size:12pt;
		margin:0;
		padding:0;
	}
	.md-toolbar-row {
		.title {
			font-size:12pt;
			margin:0;
			padding:0;
			width:100%;
			color:#000;
			text-align:center;
			position:absolute;

		}
	}
}
.md-button.bottom-write-icon-button {
	padding:0;
	margin:0;
	position:fixed;
	bottom:20px;
	right:20px;
	background:#27108C;
	width:50px;
	height:50px;
	border-radius:25px;
	text-align:center;
	i {
		color:#fff;
		text-align:center;
	}
}


.screenLayout {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height:calc(100vh);
	background-color: rgba(0, 0, 0, .5);
	display: table;
	transition: opacity .3s ease;
	.content-wrapper {
		display: table-cell;
		vertical-align: middle;
		.content-box {
			  width: 250px;
			  margin: 0px auto;
			  padding:10px 10px;
			  background-color: #fff;
			  border-radius: 5px;
			  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
			  transition: all .3s ease;
			  position:relative;
			  span {
					z-index:300;
					position:absolute;
					right:-10px;
					top:-10px;
					display:inline-block;
					width:24px;
					height:24px;
					border-radius:12px;
					border:solid 1px #dcdcdc;
					background:#222;
					color:#dcdcdc;
					text-align:center;
					line-height:20px;
					i {
						font-size:8pt;
					}
			  }
			  ul {
					
					li {
						text-align:center;
						padding:10px 0;
						color:#000;
						font-weight:bold;
					}
			  }
		}
	}
}
.swiper-pagination-bullet-active {
  opacity: 1;
  background: #27108C;
}
.md-overlay {
	min-height:1000000px;
}

.page-container {
	background:#fff;
	min-height:calc(100vh);
	.md-content {
		padding:0;width:1000px;margin:100px auto;	
	}
} 
</style>